/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompt_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove saved prompt" |
*
* @param {Assistant_Saved_Prompt_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompt_remove = /** @type {((inputs?: Assistant_Saved_Prompt_RemoveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompt_RemoveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer l'invite enregistrée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeicherte Eingabeaufforderung entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi prompt salvato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить сохранённый запрос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar solicitud guardada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除已保存的提示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存したプロンプトを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहेजा गया प्रॉम्प्ट हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover prompt guardado")
	return /** @type {LocalizedString} */ ("Remove saved prompt")
});